import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class ThumbnailService {

  constructor(public service:ApiService,public sanitizer: DomSanitizer) { }

  getThumbIcon(data) {
    this.service.getAdImage(data.imageId).subscribe(res => {
      if(res)
      data.img = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
      else 
      data.img = "assets/icon/defaultimg.png";
    },
    err=>{
      data.img = "assets/icon/defaultimg.png";
    });
  }

  getThumbIcon1(data) {
    this.service.getAdImage(data.docId).subscribe(res => {
      if(res)
      data.img = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
      else 
      data.img = "assets/icon/defaultimg.png";
    },
    err=>{
      data.img = "assets/icon/defaultimg.png";
    });
  }
}
